/**
 * 将 resolvedTheme 写到 #sse-ai-chat-root，浅色覆盖样式用 ID 选择器提高优先级，避免被 wp-admin 全局样式盖掉
 */

import React, { useLayoutEffect } from 'react';
import { useThemeStore } from '@/stores';

export const ROOT_ID = 'sse-ai-chat-root';

export const ThemeRootSync: React.FC = () => {
  const resolvedTheme = useThemeStore((s) => s.resolvedTheme);

  useLayoutEffect(() => {
    const el = document.getElementById(ROOT_ID);
    if (el) {
      el.setAttribute('data-sse-theme', resolvedTheme);
    }
  }, [resolvedTheme]);

  return null;
};
